var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textCom"},[(_vm.config.textType === 'input')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.config.centent),expression:"config.centent"}],staticClass:"text",style:({
            color:_vm.config.color,
            fontFamily:_vm.config.fontFamily,
            fontSize:_vm.config.fontSize +'px',
            fontWeight:_vm.config.fontWeight,
            textAlign:_vm.config.align,
            letterSpacing:_vm.config.letterSpacing +'px',
            background:_vm.config.backgroundColor,
            border:'none'
           }),attrs:{"type":"text","placeholder":"请在组件配置中输入内容！"},domProps:{"value":(_vm.config.centent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.config, "centent", $event.target.value)}}}):_vm._e(),(_vm.config.textType === 'textarea')?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.config.centent),expression:"config.centent"}],staticClass:"textarea",style:({
            color:_vm.config.color,
            fontFamily:_vm.config.fontFamily,
            fontSize:_vm.config.fontSize +'px',
            fontWeight:_vm.config.fontWeight,
            textAlign:_vm.config.align,
            letterSpacing:_vm.config.letterSpacing +'px',
            background:_vm.config.backgroundColor,
            border:'none'
           }),attrs:{"placeholder":"请在组件配置中输入内容！"},domProps:{"value":(_vm.config.centent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.config, "centent", $event.target.value)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }